"use client";

import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import TimeIcon from "@mui/icons-material/AccessTime";
import CalendarIcon from "@mui/icons-material/CalendarMonth";
import Image from "next/image";
import Link from "next/link";
import { formatter } from "@/lib/formatter";
import { ExternalEvent } from "@/TS/Interfaces/global_interfaces";
interface PublicExternalEventCardProps {
  event: ExternalEvent;
}
export const PublicExternalEventCard = t0 => {
  const $ = _c(26);
  const {
    event
  } = t0;
  const photoUrl = event.photo?.urls?.image_640_16_9 || event.photo?.urls?.image_384_16_9 || event.photo?.urls?.image_1080_16_9 || "/img/placeholder_event_external.svg";
  let t1;
  if ($[0] !== event.name || $[1] !== photoUrl) {
    t1 = <div className="relative w-full md:w-1/3 h-48 md:h-auto flex-shrink-0"><Image src={photoUrl} alt={event.name} fill={true} className="object-contain" /></div>;
    $[0] = event.name;
    $[1] = photoUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== event.name) {
    t2 = <h4 className="font-bold text-lg mb-2 line-clamp-2">{event.name}</h4>;
    $[3] = event.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CalendarIcon fontSize="small" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== event.startDate) {
    t4 = formatter.getEventDate(event.startDate);
    $[6] = event.startDate;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="flex items-center gap-2 text-gray-600 text-sm mb-1">{t3}<span className="capitalize">{t4}</span></div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TimeIcon fontSize="small" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== event.endDate || $[12] !== event.startDate) {
    t7 = formatter.getEventTimeRange(event.startDate, event.endDate);
    $[11] = event.endDate;
    $[12] = event.startDate;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="flex items-center gap-2 text-gray-600 text-sm mb-3">{t6}<span>{t7}</span></div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = event.url as Route;
  let t10;
  if ($[16] !== t9) {
    t10 = <div className="flex items-center justify-between mt-auto"><Link href={t9} target="_blank" rel="noopener noreferrer" className="text-red-500 font-medium hover:underline">Voir plus</Link></div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t2 || $[20] !== t5 || $[21] !== t8) {
    t11 = <div className="flex-1 p-4 relative flex flex-col">{t2}{t5}{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t2;
    $[20] = t5;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t1 || $[24] !== t11) {
    t12 = <div className="relative bg-white rounded-lg overflow-hidden shadow-md flex flex-col md:flex-row h-full min-h-[380px] md:min-h-[180px]">{t1}{t11}</div>;
    $[23] = t1;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};